import Video from "../Video/Video";
import AgilityRichText from "./AgilityRichText";

const ContentAndMedia = (props) => {
  const {
    preText,
    title,
    description,
    media,
    contentAlignment = "left",
    backgroundColor,
    buttonCTA,
    urlCTA,
  } = props;
  const isMediaVideo = /\.(mp4|webm|ogg)$/i.test(media?.url);

  return (
    <section className={`content-media lg:tw-py-25 tw-py-8 ${backgroundColor}`}>
      <div className="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 lg:tw-gap-28 tw-gap-10">
        <div
          className={`tw-content tw-flex tw-flex-col tw-justify-center lg:tw-col-span-2 ${
            contentAlignment == "right" ? "lg:tw-order-2" : ""
          }`}
        >
          {preText && (
            <div className="tw-bg-primary-red tw-w-fit tw-px-2.5 tw-py-2 tw-rounded-full tw-mb-2">
              <span className="tw-text-sm tw-text-white">{preText}</span>
            </div>
          )}
          {title && (
            <h2 className="tw-font-helv tw-text-4xl tw-font-bold tw-normal-case tw-mb-4">{title}</h2>
          )}
          {description && (
            <AgilityRichText
              html={description}
              className="[&>*]:tw-font-helv tw-mb-4"
            />
          )}
          {buttonCTA?.text && (
            <a
              href={buttonCTA.href}
              target={buttonCTA.target}
              className="tw-bg-black tw-py-2 tw-px-6 tw-w-fit tw-mb-4"
            >
              <span className="tw-font-helv lg:tw-text-xl tw-text-white">{buttonCTA.text}</span>
            </a>
          )}
          {urlCTA?.text && (
            <a
              href={urlCTA.href}
              target={urlCTA.target}
              className="tw-font-helv tw-w-fit !tw-text-primary-red !tw-underline"
            >
              {urlCTA.text}
            </a>
          )}
        </div>
        <div className="tw-media">
          {media?.url && (
            <>
              {!!isMediaVideo && <Video internalVideo={media} removeMarginBottom="true"/>}
              {!isMediaVideo && 
                <img
                  src={media.url}
                  alt={media.label || ""}
                  className="tw-w-full tw-h-auto"
                />
              }
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContentAndMedia;
